//TODO : Refactor after ai
/**
 * Route constants
 *
 * Centralized route definitions for type safety and maintainability.
 * Use these constants instead of hardcoded strings throughout the application.
 */

import {
  CUSTOM_SUB_FEATURES,
  MAIN_FEATURES,
  PAGES_NAVIGATE_METHODS,
} from "./constants";
import type { PagesRoutesType } from "./types";

export const PagesRoutes = {
  [MAIN_FEATURES.Home]: {
    [PAGES_NAVIGATE_METHODS.INDEX]: `/${MAIN_FEATURES.Home}`,
  },
  [MAIN_FEATURES.Auth]: {
    [CUSTOM_SUB_FEATURES.Login]: `/${MAIN_FEATURES.Auth}/${CUSTOM_SUB_FEATURES.Login}`,
    [CUSTOM_SUB_FEATURES.Register]: `/${MAIN_FEATURES.Auth}/${CUSTOM_SUB_FEATURES.Register}`,
    [CUSTOM_SUB_FEATURES.ForgotPassword]: `/${MAIN_FEATURES.Auth}/${CUSTOM_SUB_FEATURES.ForgotPassword}`,
    [CUSTOM_SUB_FEATURES.ResetPassword]: `/${MAIN_FEATURES.Auth}/${CUSTOM_SUB_FEATURES.ResetPassword}`,
    [CUSTOM_SUB_FEATURES.VerifyEmail]: `/${MAIN_FEATURES.Auth}/${CUSTOM_SUB_FEATURES.VerifyEmail}`,
  },
  [MAIN_FEATURES.Dashboard]: {
    [PAGES_NAVIGATE_METHODS.INDEX]: `/${MAIN_FEATURES.Dashboard}`,
    [CUSTOM_SUB_FEATURES.Statistics]: `/${MAIN_FEATURES.Dashboard}/${CUSTOM_SUB_FEATURES.Statistics}`,
  },
  [MAIN_FEATURES.Collection]: {
    [PAGES_NAVIGATE_METHODS.INDEX]: `/${MAIN_FEATURES.Collection}`,
    [PAGES_NAVIGATE_METHODS.CREATE]: `/${MAIN_FEATURES.Collection}/${PAGES_NAVIGATE_METHODS.CREATE}`,
    [PAGES_NAVIGATE_METHODS.UPDATE]: `/${MAIN_FEATURES.Collection}/${PAGES_NAVIGATE_METHODS.UPDATE}`,
    [PAGES_NAVIGATE_METHODS.SHOW]: (id: string) =>
      `/${MAIN_FEATURES.Collection}/${id}`,
  },
  // Grundgerüst Viacid: eine Übersicht und eine Detailseite je Objektklasse
  [MAIN_FEATURES.Objekte]: {
    [PAGES_NAVIGATE_METHODS.INDEX]: `/${MAIN_FEATURES.Objekte}`,
    [PAGES_NAVIGATE_METHODS.SHOW]: (slug: string, id?: string) =>
      id
        ? `/${MAIN_FEATURES.Objekte}/${slug}/${id}`
        : `/${MAIN_FEATURES.Objekte}/${slug}`,
  },
  [MAIN_FEATURES.Baustelle]: {
    [PAGES_NAVIGATE_METHODS.INDEX]: `/${MAIN_FEATURES.Baustelle}`,
  },
  [MAIN_FEATURES.Settings]: {
    [PAGES_NAVIGATE_METHODS.INDEX]: `/${MAIN_FEATURES.Settings}`,
  },
} satisfies PagesRoutesType;
